<template>
  <div class="choose-system">
    <div class="topbar">
      <div class="brand">
        <div class="crest">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M12 3 1 9l11 6 9-4.9V17h2V9L12 3Z" fill="#fff" />
            <path d="M5 13v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4l-7 3.8L5 13Z" fill="#fff" opacity=".75" />
          </svg>
        </div>
        <div>
          <b>{{ t.brand }}</b>
          <small>{{ t.brandsub }}</small>
        </div>
      </div>
      <div class="lang">
        <button :class="{ active: lang === 'ru' }" @click="setLang('ru')">
          RU
        </button>
        <button :class="{ active: lang === 'kg' }" @click="setLang('kg')">
          KG
        </button>
      </div>
    </div>

    <div class="head">
      <h1>{{ t.title }}</h1>
      <p>{{ t.subtitle }}</p>
    </div>

    <div class="cards">
      <!-- ===== БАЛАЛЫК ===== -->
      <a class="card b" href="https://balalyk.edu.gov.kg/parents" target="_blank" rel="noopener">
        <div class="blob"></div>
        <span class="age-tag">{{ t.bAge }}</span>

        <div class="icon-wrap">
          <svg width="56" height="56" viewBox="0 0 28 29" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.5188 26.2242L13.8984 20.1769L12.278 26.2242C11.6263 28.6567 8.36533 29.0994 7.0886 26.9288C5.74691 24.6477 3.84566 22.7465 1.56459 21.4048C-0.606028 20.1281 -0.163297 16.8671 2.26916 16.2154L8.31656 14.595L2.26916 12.9746C-0.163293 12.3228 -0.606028 9.06186 1.5646 7.78514C3.84567 6.44343 5.74691 4.54219 7.0886 2.26112C8.36533 0.0905043 11.6263 0.533239 12.278 2.9657L13.8984 9.01305L15.5188 2.9657C16.1706 0.533239 19.4315 0.0905043 20.7082 2.26114C22.0499 4.54221 23.9512 6.44345 26.2322 7.78514C28.4029 9.06188 27.9601 12.3228 25.5277 12.9746L19.4803 14.595L25.5277 16.2154C27.9601 16.8671 28.4029 20.1281 26.2322 21.4048C23.9512 22.7465 22.0499 24.6477 20.7082 26.9288C19.4315 29.0994 16.1706 28.6567 15.5188 26.2242Z"
              fill="#0ACD9A" />
          </svg>
        </div>

        <div class="logo-row">
          <div class="logo-text">
            <span class="name">{{ t.bName }}</span>
            <span class="sub">{{ t.bSub }}</span>
          </div>
        </div>

        <h2>{{ t.bH }}</h2>

        <div class="feat">
          <span>{{ t.bF1 }}</span>
          <span>{{ t.bF2 }}</span>
          <span>{{ t.bF3 }}</span>
        </div>

        <div class="go">
          <span>{{ t.bGo }}</span>
          <span class="arrow">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </div>
      </a>

      <!-- ===== МЕКТЕП ===== -->
      <a class="card m" href="https://1mektep.edu.gov.kg/ru" target="_blank" rel="noopener">
        <div class="blob"></div>
        <span class="age-tag">{{ t.mAge }}</span>

        <div class="icon-wrap">
          <svg width="56" height="56" viewBox="0 0 34 34" fill="none">
            <path opacity="0.5" d="M17.0021 29.405L1 24.3958V5.30225L17.0021 10.3115V29.405Z" fill="url(#cs_p0)" />
            <path d="M17.0021 29.405L4.84796 19.6885V0.594971L17.0021 10.3114" fill="url(#cs_p2)" />
            <path opacity="0.5" d="M17.0021 29.405L33.0073 24.3958V5.30225L17.0021 10.3115V29.405Z"
              fill="url(#cs_p3)" />
            <path d="M17.0021 29.405L29.1593 19.6885V0.594971L17.0021 10.3114" fill="url(#cs_p5)" />
            <defs>
              <linearGradient id="cs_p0" x1="1" y1="17.3537" x2="17.0033" y2="17.3537" gradientUnits="userSpaceOnUse">
                <stop stop-color="#96E7FF" />
                <stop offset="0.9997" stop-color="#007FF6" />
              </linearGradient>
              <linearGradient id="cs_p2" x1="4.84644" y1="15.0001" x2="17.0033" y2="15.0001"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#9DEAFF" />
                <stop offset="0.9985" stop-color="#007FF6" />
              </linearGradient>
              <linearGradient id="cs_p3" x1="17.0033" y1="17.3537" x2="33.0065" y2="17.3537"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.00029408" stop-color="#007FF6" />
                <stop offset="0.9982" stop-color="#96E7FF" />
              </linearGradient>
              <linearGradient id="cs_p5" x1="17.0033" y1="15.0001" x2="29.1601" y2="15.0001"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.00147132" stop-color="#007FF6" />
                <stop offset="1" stop-color="#9DEAFF" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div class="logo-row">
          <div class="logo-text">
            <span class="name">{{ t.mName }}</span>
            <span class="sub">{{ t.mSub }}</span>
          </div>
        </div>

        <h2>{{ t.mH }}</h2>

        <div class="feat">
          <span>{{ t.mF1 }}</span>
          <span>{{ t.mF2 }}</span>
          <span>{{ t.mF3 }}</span>
        </div>

        <div class="go">
          <span>{{ t.mGo }}</span>
          <span class="arrow">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </div>
      </a>
    </div>

    <footer>
      <span>{{ t.foot }}</span>
    </footer>
  </div>
</template>

<script>
const TRANSLATIONS = {
  ru: {
    brand: "Образование КР",
    brandsub: "Единый портал зачисления",
    title: "Выберите систему образования",
    subtitle:
      "Запись в детский сад или школу — выберите подходящий раздел, чтобы продолжить.",
    bAge: "от 0 до 6 лет",
    bName: "Балалык",
    bSub: "Дошкольное образование",
    bH: "Запись в детский сад",
    bF1: "Электронная очередь",
    bF2: "Выбор сада",
    bF3: "Статус заявки",
    bGo: "Перейти в Балалык",
    mAge: "от 6 до 7 лет",
    mName: "Мектеп",
    mSub: "Школьное образование",
    mH: "Запись в школу",
    mF1: "Зачисление в 1 класс",
    mF2: "Выбор школы",
    mF3: "Язык обучения",
    mGo: "Перейти в Мектеп",
    foot: "© Министерство просвещения Кыргызской Республики",
  },
  kg: {
    brand: "КР билим берүү",
    brandsub: "Бирдиктүү кабыл алуу порталы",
    title: "Билим берүү системасын тандаңыз",
    subtitle:
      "Бала бакчага же мектепке каттоо — улантуу үчүн тиешелүү бөлүмдү тандаңыз.",
    bAge: "0дөн 6 жашка чейин",
    bName: "Балалык",
    bSub: "Мектепке чейинки билим",
    bH: "Бала бакчага каттоо",
    bF1: "Электрондук кезек",
    bF2: "Бакчаны тандоо",
    bF3: "Арыздын абалы",
    bGo: "Балалыкка өтүү",
    mAge: "6дан 7 жашка чейин",
    mName: "Мектеп",
    mSub: "Мектептик билим",
    mH: "Мектепке каттоо",
    mF1: "1-класска кабыл алуу",
    mF2: "Мектепти тандоо",
    mF3: "Окутуу тили",
    mGo: "Мектепке өтүү",
    foot: "© Кыргыз Республикасынын Билим берүү министрлиги · Санариптик Билим борбору",
  },
};

export default {
  name: "ChooseSystem",
  data() {
    return {
      lang: "ru",
    };
  },
  computed: {
    t() {
      return TRANSLATIONS[this.lang];
    },
  },
  methods: {
    setLang(lang) {
      this.lang = lang;
      document.documentElement.lang = lang;
    },
  },
};
</script>

<style scoped>
.choose-system {
  --balalyk: #0acd9a;
  --balalyk-dark: #089e77;
  --balalyk-soft: #e3faf3;
  --mektep: #007ff6;
  --mektep-dark: #0066cc;
  --mektep-soft: #e6f2ff;
  --ink: #222934;
  --muted: #71798a;
  --bg: #f3f5f9;
  --card: #ffffff;

  font-family: "Manrope", system-ui, sans-serif;
  color: var(--ink);
  background: radial-gradient(900px 500px at 12% 8%,
      rgba(10, 205, 154, 0.16),
      transparent 60%),
    radial-gradient(900px 500px at 88% 92%,
      rgba(0, 127, 246, 0.16),
      transparent 60%),
    var(--bg);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  overflow-x: hidden;
}

.choose-system * {
  box-sizing: border-box;
}

/* ---- top bar ---- */
.topbar {
  width: 100%;
  max-width: 1080px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 54px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.brand .crest {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--mektep), var(--balalyk));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 22px rgba(0, 127, 246, 0.28);
}

.brand small {
  display: block;
  font-weight: 500;
  color: var(--muted);
  font-size: 12px;
  margin-top: 2px;
}

.brand b {
  font-size: 15px;
}

.lang {
  display: flex;
  background: #fff;
  border-radius: 999px;
  padding: 4px;
  box-shadow: 0 4px 14px rgba(20, 30, 60, 0.07);
}

.lang button {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  font-size: 13px;
  color: var(--muted);
  padding: 8px 16px;
  border-radius: 999px;
  transition: 0.2s;
}

.lang button.active {
  background: var(--ink);
  color: #fff;
}

/* ---- heading ---- */
.head {
  text-align: center;
  max-width: 620px;
  margin-bottom: 46px;
  opacity: 0;
  transform: translateY(16px);
  animation: cs-rise 0.7s 0.05s forwards;
}

.head h1 {
  font-family: "Unbounded", sans-serif;
  font-weight: 700;
  font-size: clamp(28px, 4.4vw, 46px);
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.head p {
  margin-top: 14px;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.6;
}

/* ---- cards ---- */
.cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  width: 100%;
  max-width: 1000px;
}

.card {
  position: relative;
  display: block;
  text-decoration: none;
  color: inherit;
  background: var(--card);
  border-radius: 28px;
  padding: 40px 36px 34px;
  border: 1px solid rgba(20, 30, 60, 0.06);
  box-shadow: 0 18px 44px rgba(20, 30, 60, 0.08);
  overflow: hidden;
  transition: transform 0.35s cubic-bezier(0.2, 0.7, 0.2, 1), box-shadow 0.35s;
  opacity: 0;
  transform: translateY(26px);
}

.card.b {
  animation: cs-rise 0.7s 0.2s forwards;
}

.card.m {
  animation: cs-rise 0.7s 0.32s forwards;
}

.card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 28px;
  padding: 1.5px;
  opacity: 0;
  transition: opacity 0.35s;
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

.card.b::before {
  background: linear-gradient(135deg, var(--balalyk), transparent);
}

.card.m::before {
  background: linear-gradient(135deg, var(--mektep), transparent);
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(20, 30, 60, 0.16);
}

.card:hover::before {
  opacity: 1;
}

.blob {
  position: absolute;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  filter: blur(8px);
  opacity: 0.5;
  top: -110px;
  right: -90px;
  transition: 0.4s;
}

.card.b .blob {
  background: radial-gradient(circle, var(--balalyk-soft), transparent 70%);
}

.card.m .blob {
  background: radial-gradient(circle, var(--mektep-soft), transparent 70%);
}

.card:hover .blob {
  transform: scale(1.25);
}

.icon-wrap {
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
  transition: transform 0.4s cubic-bezier(0.2, 0.7, 0.2, 1);
}

.card.b .icon-wrap {
  background: var(--balalyk-soft);
}

.card.m .icon-wrap {
  background: var(--mektep-soft);
}

.card:hover .icon-wrap {
  transform: rotate(-6deg) scale(1.06);
}

.logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1;
}

.logo-text .name {
  font-family: "Unbounded", sans-serif;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -0.3px;
}

.card.b .logo-text .name {
  color: var(--balalyk-dark);
}

.card.m .logo-text .name {
  color: var(--mektep-dark);
}

.logo-text .sub {
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  margin-top: 6px;
  letter-spacing: 0.3px;
}

.card h2 {
  font-size: 21px;
  font-weight: 800;
  margin: 24px 0 4px;
  letter-spacing: -0.2px;
}

.feat {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 18px 0 26px;
}

.feat span {
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 11px;
  border-radius: 8px;
}

.card.b .feat span {
  background: var(--balalyk-soft);
  color: var(--balalyk-dark);
}

.card.m .feat span {
  background: var(--mektep-soft);
  color: var(--mektep-dark);
}

.go {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 15px;
  padding-top: 20px;
  border-top: 1px solid rgba(20, 30, 60, 0.07);
}

.card.b .go {
  color: var(--balalyk-dark);
}

.card.m .go {
  color: var(--mektep-dark);
}

.go .arrow {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: transform 0.35s;
}

.card.b .go .arrow {
  background: var(--balalyk);
}

.card.m .go .arrow {
  background: var(--mektep);
}

.card:hover .go .arrow {
  transform: translateX(6px);
}

.age-tag {
  position: absolute;
  top: 32px;
  right: 32px;
  font-size: 12px;
  font-weight: 700;
  padding: 7px 13px;
  border-radius: 999px;
  color: #fff;
}

.card.b .age-tag {
  background: var(--balalyk);
}

.card.m .age-tag {
  background: var(--mektep);
}

footer {
  margin-top: 54px;
  color: var(--muted);
  font-size: 13px;
  text-align: center;
  opacity: 0;
  animation: cs-rise 0.7s 0.5s forwards;
}

@keyframes cs-rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 760px) {
  .choose-system {
    padding: 32px 18px;
  }

  .cards {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .topbar {
    margin-bottom: 38px;
  }

  .head {
    margin-bottom: 34px;
  }

  .card {
    padding: 32px 26px 28px;
  }
}
</style>
